import { TableColumnOrder } from '@/types';

export const descendingComparator = <CustomType>(
  a: CustomType,
  b: CustomType,
  orderBy: keyof CustomType
): number => {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
};

type GetComparatorInterface = (a: any, b: any) => number;

export const getComparator = <CustomType>(
  order: TableColumnOrder,
  orderBy: keyof CustomType | string
): GetComparatorInterface => {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy as keyof CustomType)
    : (a, b) => -descendingComparator(a, b, orderBy as keyof CustomType);
};
